import React from 'react';
import Icon from './Icon';

const PinIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 21.5C12 21.5 19 14.2 19 9.5C19 5.63 15.87 2.5 12 2.5C8.13 2.5 5 5.63 5 9.5C5 14.2 12 21.5 12 21.5ZM14.5 9.5A2.5 2.5 0 1 1 9.5 9.5A2.5 2.5 0 0 1 14.5 9.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default PinIcon;
